export function orderTable() {
    const toggleButton = document.querySelector('.checkout-review-table-toggle');
    const orderTableWrapper = document.querySelector('.checkout-review-wrapper');
    const toggleIcon = document.querySelector('.checkout-review-table-toggle-icon');
    let isTableExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

    if (toggleButton && orderTableWrapper) {
        toggleButton.addEventListener('click', () => {
            isTableExpanded = !isTableExpanded;

            document.body.style.overflow = isTableExpanded ? 'hidden' : 'auto';
            toggleIcon.classList.toggle('is-rotated', isTableExpanded);
            toggleButton.setAttribute('aria-expanded', isTableExpanded ? 'true' : 'false');
            orderTableWrapper.style.display = isTableExpanded ? 'block' : 'none';
        });
    }
}
